import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction, updateSimpleStore } from '@om-fe/store';
import { ModelTypes } from '@om-fe/models';
import { getTopBetSliceName } from './nav.utils';
import { TopBetsActions } from './nav.constants';
export interface LocationModel {
    readonly _type: ModelTypes.LOCATION;
    readonly id: string;
    readonly typeId: string;
    readonly name: string;
    readonly shortName: string;
    readonly code: string;
    readonly numberOfEvents: number;
    readonly numberOfMarkets: number;
    readonly numberOfBettingOffers: number;
    readonly numberOfLiveBettingOffers: number;
    readonly numberOfLiveEvents: number;
    readonly numberOfLiveMarkets: number;
    readonly numberOfUpcomingMatches: number;
}
export interface NavListItemModel {
    readonly name: string;
    readonly shortName: string;
    readonly id: string;
}
export interface NavListStateModel {
    readonly ready: boolean;
    readonly items: Record<string, NavListItemModel>;
    readonly list: string[];
    readonly disciplineId: string;
    readonly isCategory?: boolean;
}

const initialState: NavListStateModel = {
    ready: false,
    list: [],
    items: {},
    disciplineId: '',
    isCategory: false,
};

export const locationNavReducerCreator = (instanceId: string) => (
    state: NavListStateModel = initialState,
    action: AppAction,
): NavListStateModel => {
    const slice: string = getTopBetSliceName(instanceId);

    const { meta, payload } = action;
    
    if (!meta || meta.slice !== slice) {
        return state;
    }

    switch (action.type) {
        case TopBetsActions.SetFilterData: {

            return {
                ...state,
                disciplineId: payload.disciplineId,
                isCategory: payload.isCategory,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const items: Record<string, NavListItemModel> = {};
            const { records } = payload;

            const list: string[] = records.map((item: LocationModel): string => {
                const {
                    id,
                    name,
                    shortName,
                } = item;

                items[id] = {
                    id,
                    name,
                    shortName,
                };

                return id;
            });
            
            return {
                ...state,
                ready: true,
                list,
                items
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {

            return updateSimpleStore<LocationModel, NavListItemModel, NavListStateModel>(state, payload, {
                id: 'id',
                name: 'name',
                shortName: 'shortName',
            });
        }
        default:
            return state;
    }
};

